import { useMemo } from 'react';
import { formatLocalTime } from '../services/helpers';

const useFormatPhotoTimestamp = (photo, serverTimezone) => useMemo(() => formatLocalTime({
  entity: photo,
  serverTimezone,
  format: 'llll zz',
}),
[photo, serverTimezone]);

export default useFormatPhotoTimestamp;
